<script setup>
import { computed, onBeforeMount, watch, ref } from 'vue'
import { useStore } from 'vuex'
import { useRoute } from 'vue-router'

import { FormProject } from '@/components/forms'

const store = useStore()
const route = useRoute()

const orgId = computed(() => route.params.org_id ? parseInt(String(route.params.org_id)) : null)
const projectId = computed(() => route.params.project_id ? parseInt(String(route.params.project_id)) : null)
const project = computed(() => store.getters['project/current'])
const isLoading = ref(true)

// Create a fake project object for new project creation
const createProjectData = computed(() => {
  if (projectId.value) {
    // Creating a sub-project - use parent project data
    return project.value
  } else {
    // Creating a regular project - use org_id from route
    return {
      project_id: null,
      organization_id: orgId.value,
      parent_id: null
    }
  }
})

onBeforeMount(async () => {
  // Ensure orgs are loaded to display org name
  await store.dispatch('org/fetchOrgs')

  if (projectId.value) {
    // Load parent project data if creating a sub-project
    await store.dispatch('project/fetchProject', projectId.value)
  }
  isLoading.value = false
})

watch(() => projectId.value, async (value) => {
  isLoading.value = true
  if (value) {
    await store.dispatch('project/fetchProject', value)
  }
  isLoading.value = false
})
</script>

<template>
  <div class="p-2">
    <div v-if="!isLoading && createProjectData" :key="createProjectData?.project_id || 'new'">
      <FormProject
        :project="createProjectData"
        :key="createProjectData?.project_id || 'new'"
      />
    </div>
    <div v-else>
      <p>Loading...</p>
    </div>
  </div>
</template>
